import React from 'react';
import MainMenuComponent from '../../Components/Menus/MainMenuComponent';

const ConfigurationPage = () => {
  return <MainMenuComponent menuName="configuration" />;
};

export default ConfigurationPage;
